import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { decrypt, encrypt } from '../auth/crypto.util';
// import { AuthenticationService } from '../../../authentication.service';
import { LanguageService } from '../language.service';
@Injectable({
  providedIn: 'root'
})
export class CommonsService {
  // private aseUrl = `${environment.apiUrl}/reports`;
  public httpUrl: any;
  
  categories: any[] = [ { value:{en: "Development Authority", hi: "विकास प्राधिकरण"},code:"Development Authority" },{value:{en: "Awas Vikas Parishad", hi: "आवास विकास परिषद"}, code:"Awas Vikas Parishad" }, { value:{en: "Special Authority", hi: "विशेष प्राधिकरण"}, code:"Special Authority" }, { value:{en: "Special Area Development Authority", hi: "विशेष क्षेत्र विकास प्राधिकरण"}, code:"Special Area Development Authority" }];
  categoriesObjShow: any = { "Development Authority": {en: "Development Authority", hi: "विकास प्राधिकरण"}, "Awas Vikas Parishad": {en: "Awas Vikas Parishad", hi: "आवास विकास परिषद"}, "Special Authority": {en: "Special Authority", hi: "विशेष प्राधिकरण"}, "Special Area Development Authority": {en: "Special Area Development Authority", hi: "विशेष क्षेत्र विकास प्राधिकरण"} };
  constructor(private http: HttpClient, private languageService: LanguageService) {
    console.log(environment.apiUrl)
    this.httpUrl = `${environment.apiUrl}`;
    if(this.month==1 || this.month==2 || this.month==3){
      this.year = this.year -1
    }
    this.loadUserFromStorage();
 
  }
  shouldRefreshForms: boolean = false;
 
  formState: any = {};
  addData: any
  sessionsObj: any
  sessionsFinObj: any = {}
  monthsObj: any
  [key: string]: any;
  user: any
  vch_enable: boolean = true;
  year = new Date().getFullYear();
  month = new Date().getMonth() + 1;
   premonthObj:any = {1:12,2:1,3:2,4:3,5:4,6:5,7:6,8:7,9:8,10:9,11:10,12:11}
  finalizeStatusObj: any = { 'Y':{'en': "Finalised", 'hi': "अंतिम रूप"}, 'N':{'en': "Draft", 'hi': "ड्राफ़्ट"} ,'C':{'en': "CORRECTION", 'hi': "सुधार`"}   }
  getSession(): Observable<any> {
    return this.http.get(`${this.httpUrl}/common/getSession`);
  }
  getAuthorities(u_type: string, da_id: number, lang: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/common/getAuthorities`+ JSON.stringify(
        {
        u_type: u_type,   da_id: da_id,   lang: lang,  vch_enable: this.vch_enable
      })
    );
  }
  clearStorage(): void {
  this.user = null;
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('1000');
  sessionStorage.removeItem('1005');   
}
get currentUser() {
  if (!this.user) {
    this.loadUserFromStorage();
  }
  return this.user;
}
loadUserFromStorage(): void {
  try {
    const enc = sessionStorage.getItem('user');
    if (enc) {
      const decrypted = decrypt(enc);
      if (decrypted) {
        this.user = decrypted;           
        // this.token = decrypted.token;           
      } else {
        sessionStorage.removeItem('user');
      }
    }
  } catch (e) {
    console.error('Error loading user from storage', e);
    sessionStorage.removeItem('user');
  }
}

saveUserToStorage(): void {
  try {
    if (this.user) {
      sessionStorage.setItem('user', encrypt(this.user));
    } else {
      sessionStorage.removeItem('user');
    }
  } catch (e) {
    console.error('Error saving user to storage', e);
  }
}

 

 
  getserver(): Observable<any> {
    return this.http.get(`${this.httpUrl}`);
  }

 

  getForms(lang:string): Observable<any> {
    return this.http.get(`${this.httpUrl}/annex/getAnnex?lang=${lang}`);
  }
  getNFAuthorityMappings(): Observable<any> {
    return this.http.get(`${this.httpUrl}/nfAuth/getMappings`);
  }
  getMonth(sessionId: any, lang?: string): Observable<any> {
    const language = lang || this.languageService.language$.getValue();
    return this.http.get(`${this.httpUrl}/common/getMonth?session_id=${sessionId}&lang=${language}`);
  }
  getCurrentMonthDashData(session_id: number, month_id: number,u_type:string,da_id:any,lang:string): Observable<any> {
    return this.http.get(`${this.httpUrl}/common/getCurrentMonthDashData?session_id=${session_id}&month_id=${month_id}&u_type=${u_type}&da_id=${da_id}&lang=${lang}`);
  }
  docsData(payload: any) {
  return this.http.get<any[]>(
    `${this.httpUrl}/doc/docsData`+JSON.stringify(payload)
     
  );
}
 
getDocs(payload: any) {
  return this.http.post(
    `${this.httpUrl}/doc/getDocs`,
    payload,
    { responseType: 'blob' } 
  );
}
 
  getDaRegisteredList(): Observable<any> {
    return this.http.get(`${this.httpUrl}/daRegistration/registeredList`);
  }
  getDaList(): Observable<any> {
    let lang = this.languageService.language$.getValue();
    return this.http.get(`${this.httpUrl}/daRegistration/getDaName`+JSON.stringify({lang:lang}));
  }
  getDistrictList(): Observable<any> {
     let lang = this.languageService.language$.getValue();
    return this.http.get(`${this.httpUrl}/daRegistration/getDistrict`+JSON.stringify({lang:lang}));
  }
 newRegistration(obj: any): Observable<any> {
  return this.http.post(`${this.httpUrl}/daRegistration/registration`, obj, { responseType: 'blob' });
}
updateRegisteredData(int_id: number, obj: any): Observable<any> {
  obj['int_id'] = int_id;
  return this.http.post(`${this.httpUrl}/daRegistration/updateRegisteredData`, obj);
}
loginApproval(int_id: number, obj: any) {
obj['int_id'] = int_id;
  return this.http.post(
    `${this.httpUrl}/daRegistration/approvedLogin`,
    obj
  );
}

 
uploadDocument(  file: File,da_id: number, annex: string,annex_id: number,remark:any): Observable<any> {
  const formData = new FormData();
  formData.append('file', file);          
  formData.append('da_id', da_id.toString());
  formData.append('annex', annex);
  formData.append('annex_id', annex_id.toString());
  formData.append('remark', remark.toString());
  return this.http.post(
    `${this.httpUrl}/doc/upload`,
    formData
  ).pipe(
    tap({
      next: (response) => console.log('Upload API called successfully:', response),
      error: (error) => console.error('Upload API call failed:', error)
    })
  );}

                                             // New start 

// loadSessionData(component: any): Promise<void> {
//   return new Promise((resolve, reject) => {
//     this.getSession().subscribe({
//       next: async (data: any[]) => {
//         try {
//           this.sessionsObj = {};
//           this.sessionsFinObj = {};
//           data.map(x => {
//             this.sessionsObj[x['id']] = x;
//             this.sessionsFinObj[x['fin_year']] = x;
//           });
//           component.selectedSession = this.sessionsFinObj[this.year]['id'];
//           component.sessions = data;
//           component.sessionsObj = this.sessionsObj; 
//           console.log('Session data:', data);
//           resolve();
//         } catch (err) {
//           reject(err);
//         }
//       },
//       error: (err) => {
//         console.error('Error fetching session data', err);
//         reject(err);
//       }
//     });
//   });
// }


loadMonthData(component: any, sessionId: number, lang?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!sessionId) {
        component.months = [];
        resolve();
        return;
      }
      this.getMonth(sessionId, lang).subscribe({
      next: (data: any[]) => {
        this.monthsObj = {};
        component.months = [];
        data.forEach((m: any) => {
          const processedMonth = {
            ...m,
            monthname: m.monthname ? m.monthname.split(',')[0] : ''
          };
          component.months.push(processedMonth);
          this.monthsObj[m['month_no']] = processedMonth;
        });
        component.selectedMonth = this.monthsObj[this.month]?.month_no;
        component.monthsObj = this.monthsObj; 
        console.log('Month data:', component.months);
        resolve();
      },
      error: (err) => {
        console.error('Month data error', err);
        reject(err); 
      }
    });
  });
  
}
                          // New End
                    
  loadSessionData(component: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.getSession().subscribe({
        next: async (data: any[]) => {
          try {
            this.sessionsObj = {};
            this.sessionsFinObj = {};
            data.map(x => {
              this.sessionsObj[x['id']] = x;
              this.sessionsFinObj[x['fin_year']] = x;
            });
            component.selectedSession = this.sessionsFinObj[this.year]['id'];
            component.sessions = data;
            console.log('Session data:', data);

            resolve();
          } catch (err) {
            reject(err);
          }
        },
        error: (err) => {
          console.error('Error fetching session data', err);
          reject(err);
        }
      });
    });
  }



  // loadMonthData(component: any, sessionId: number): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     if (!sessionId) {
  //       component.months = [];
  //       resolve(); // No data, resolve immediately
  //       return;
  //     }

  //     this.getMonth(sessionId).subscribe({
  //       next: (data: any[]) => {
  //         this.monthsObj = {};
  //         component.months = [];

  //         data.forEach((m: any) => {
  //           component.months.push({
  //             ...m,
  //             monthname: m.monthname ? m.monthname.split(',')[0] : ''
  //           });
  //           this.monthsObj[m['month_no']] = m;
  //         });

  //         component.selectedMonth = this.monthsObj[this.month]?.month_no;
  //         component.monthsObj = this.monthsObj; //new
  //       console.log('Month data:', component.months);
  //       resolve();

  //       },
  //       error: (err) => {
  //         console.error('Month data error', err);
  //         reject(err); // ❌ Reject on error
  //       }
  //     });
  //   });
  // }

  loadSpecificMonthData(component: any, sessionId: number) {
    if (!sessionId) {
      component.months = [];
      return;
    }

    this.getMonth(sessionId).subscribe({
      next: (data: any[]) => {
        this.monthsObj = {};
        component.months = [];

        // [TEMPORARY BYPASS] Commented out to allow all months (instead of just April–November)
        const validMonths = data.filter(
          (m: any) => m.month_no >= 4 && m.month_no <= 11
        );
        // const validMonths = data;

        component.months = validMonths.map((m: any) => ({
          ...m,
          monthname: m.monthname ? m.monthname.split(',')[0] : ''
        }));

        const currentMonth = new Date().getMonth() + 1;
        const current = validMonths.find((m: any) => m.month_no === currentMonth);

        component.selectedMonthId = current
          ? current.month_no
          : validMonths.length > 0
            ? validMonths[0].month_no
            : null;

        data.forEach((m: any) => (this.monthsObj[m['month_no']] = m));

        console.log('Loaded months (April–November):', component.months);
      },
      error: (err) => {
        console.error('Error fetching month data', err);
      }
    });
  }



  fetchAuthorities(component: any) {
    let lang = this.languageService.language$.getValue();
    return new Promise((resolve, reject) => {
      this.getAuthorities(this.user.u_type, this.user.da_id, lang).subscribe({
        next: (data: any[]) => {
          if (this.user.u_type == "A") {
            component.authorities = data
            resolve(component.authorities)
            return
          }
          component.authorities = data.filter(x => this.user.da_id == x.da_id)
          resolve(component.authorities)
        },
        error: (err) => {
          reject([])
          console.error('Error fetching specific session', err);
        }
      });
    })
  }
  
fetchForms(component: any): Promise<any[]> {
   let lang = this.languageService.language$.getValue();
  return new Promise((resolve, reject) => {
    this.getForms(lang).subscribe({
      next: (data: any[]) => {
        component.formList = data;
        resolve(data);
      },
      error: (err) => {
        console.error('Error fetching forms', err);
        reject(err);
      }
    });
  });
}
 
  loadSpecificSession(component: any) {
    this.getSession().subscribe({
      next: (data: any[]) => {
        this.sessionsObj = {};
        data.forEach(s => this.sessionsObj[s['id']] = s);

        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        console.log(currentMonth, currentYear);

        const nextYear = currentYear + 1;
        const prevYear = currentYear - 1;

        let currentSessionStr = '';
        if (currentMonth >= 8) {
          currentSessionStr = `${currentYear}-${nextYear}`;
        } else {
          currentSessionStr = `${prevYear}-${currentYear}`;
        }

        const currentSession = data.find(
          s => s.session?.trim() === currentSessionStr
        );

        if (currentSession) {
          component.sessions = [currentSession];
          // component.selectedSessionId = currentSession.id;
          component.selectedSession1 = currentSession.id;
          console.log(' Showing only current session:', currentSession.session);

          component.setDefaultMonth();
          if (component.onSessionChange) {
            component.onSessionChange();
          }
        } else {
          console.warn(' No matching current session found. Showing all sessions.');
          component.sessions = data;
        }
      },
      error: (err) => {
        console.error('Error fetching specific session', err);
      }
    });
  }


  // loadSpecificSession(component: any, sessionId: number) {
  //   this.getSession().subscribe({
  //     next: (data: any[]) => {
  //       const filtered = data.filter(s => s.id === sessionId || s.session === '2025-2026');
  //       component.sessions = filtered;
  //       if (filtered.length > 0) {
  //         component.selectedSessionId = filtered[0].id;
  //         console.log('Specific session (2025-2026):', filtered[0]);
  //         component.onSessionChange();
  //       } else {
  //         console.warn('Session 2025-2026 not found.');
  //       }
  //     },
  //     error: (err) => {
  //       console.error('Error fetching specific session', err);
  //     }
  //   });
  // }
  // loadMonthData(component: any, sessionId: number) {
  //   if (!sessionId) {
  //     component.months = [];
  //     return;
  //   }

  //   this.getMonth(sessionId).subscribe({
  //     next: (data: any[]) => {
  //       component.months = data;
  //       console.log('Month data:', data);
  //     },
  //     error: (err) => {
  //       console.error('Error fetching month data', err);
  //     }
  //   });
  // }

  // Forms and Services


  getAnnexRecords(obj: any): Observable<any> {
    obj['lang']= this.languageService.language$.getValue();
        return this.http.get(`${this.httpUrl}/reports/getAnnexRecords` + JSON.stringify(obj));
  }
  

  checkAdd(obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/common/checkAdd` + JSON.stringify(obj));
  }
 
 agencyProfile(id: number) {
    return this.http.get(`${this.httpUrl}/authrityProfile/agencyProfile`, {
      params: { id }
    });
  }
updateAgencyProfile(id: number, payload: any) {
  return this.http.put(
    `${this.httpUrl}/authrityProfile/updateAgencyProfile/${id}`,
    payload
  );
}
updatePassword(id: number, payload: any) {
  payload['id'] = id;
  return this.http.post(
    `${this.httpUrl}/authrityProfile/updatePassword`,
    payload
  );
}

 

  getAnnexAllRecords(annex_no: any, obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/annex${annex_no}/getAnnex${annex_no}Records` + JSON.stringify(obj));
  }

  getnotice(): Observable<any> {
  console.log(' Calling Notice API...');
  return this.http.get(`${this.httpUrl}/mst_notice_master/notice`).pipe(
    tap(res => console.log(' Notice API Response:', res))
  );
}



  getAnnex65Parts(annex_no: any, obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/annex${annex_no}/getAnnex65Parts` + JSON.stringify(obj));
  }

  getUpdateAllRecords(annex_no: any, obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/annex${annex_no}/getupdate${annex_no}Records` + JSON.stringify(obj));
  }
  
  getAnnexAllForAdd(annex_no: any, obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/annex${annex_no}/forAddAnnex${annex_no}Records` + JSON.stringify(obj));
  }
  getProjectMasterEWS(annex_no: any, obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/annex${annex_no}/ProjectMaster${annex_no}EWS` + JSON.stringify(obj));
  }


  annexAllRecords(annex_no: any, obj: any): Observable<any> {
    return this.http.post(`${this.httpUrl}/annex${annex_no}/injectAnnex${annex_no}`, obj);
  }

  annexAllUpdateRecords(annex_no: any, update_id: any, obj: any): Observable<any> {
    return this.http.put(`${this.httpUrl}/annex${annex_no}/updateAnnex${annex_no}/${update_id}`, obj);
  }

 

  finaliseAllAnnexRecords(annex_no: any, obj: any): Observable<any> {
    return this.http.put(`${this.httpUrl}/annex${annex_no}/finalizeAnnex${annex_no}`, obj);
  }


  getPdfReport(obj: any): Observable<any> {
    return this.http.post(`${this.httpUrl}/pdfGen/genPdfReport`, obj, { responseType: 'blob' });
  }

  getPdfReportStream(obj: any): Observable<any> {
    return new Observable(subscriber => {
      const token = sessionStorage.getItem('1000');
      const headers: any = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      fetch(`${this.httpUrl}/pdfGen/genPdfReport`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(obj),
        credentials: 'include'
      }).then(async response => {
        const reader = response.body?.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        if (!reader) {
          subscriber.error('Failed to read stream');
          return;
        }

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (const line of lines) {
            if (line.trim()) {
              try {
                const data = JSON.parse(line);
                subscriber.next(data);
              } catch (e) {
                console.error('Error parsing line', e);
              }
            }
          }
        }
        subscriber.complete();
      }).catch(err => subscriber.error(err));
    });
  }

  getPdfAllReport(obj: any): Observable<any> {
    return this.http.post(`${this.httpUrl}/pdfGen/genPdfAllReport`, obj, { responseType: 'blob' });
  }

  getPdfAllReportStream(obj: any): Observable<any> {
    return new Observable(subscriber => {
      const token = sessionStorage.getItem('1000');
      const headers: any = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      fetch(`${this.httpUrl}/pdfGen/genPdfAllReport`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(obj),
        credentials: 'include'
      }).then(async response => {
        const reader = response.body?.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        if (!reader) {
          subscriber.error('Failed to read stream');
          return;
        }

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (const line of lines) {
            if (line.trim()) {
              try {
                const data = JSON.parse(line);
                subscriber.next(data);
              } catch (e) {
                console.error('Error parsing line', e);
              }
            }
          }
        }
        subscriber.complete();
      }).catch(err => subscriber.error(err));
    });
  }



  getExcelReport(obj: any): Observable<any> {
    return this.http.post(`${this.httpUrl}/excelGen/getExcelReport`, obj, { responseType: 'blob' });
  }
 


  checkFutureRecords(obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/common/checkFutureRecords` + JSON.stringify(obj));
  }

  getCmReviewReport(payload: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/reports/cmReviewReport?session_id=${payload.session_id}&month_start=${payload.month_start}&month_end=${payload.month_end}`);
  }

  getCmReviewReport68(payload: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/reports/cmReviewReport68?session_id=${payload.session_id}&month_start=${payload.month_start}&month_end=${payload.month_end}`);
  }

}